import { groupComponents } from '~/page-template/component-map';
import { type ComponentTypeNames } from '~/types/template';

export const isGroupComponent = (name: keyof ComponentTypeNames) => {
  return !!groupComponents[name];
};
